"use client";
import React, { useState } from "react";
import Iframe from 'react-iframe'
import styles from "./styles.module.css";
import Image from "next/image";

interface CounterProps {
  imagen: string;
  alt: string;
  videoId?: string;
}

function VideoModal({ imagen, alt, videoId }: CounterProps) {

  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className="cursor-pointer"  onClick={() => setIsOpen(true)}>
        <Image src={imagen} alt={alt} width={500} height={800}/>
      </div>

      {isOpen && (
        <div onClick={() => setIsOpen(false)} className="fixed inset-0 bg-white bg-opacity-70 flex items-center justify-center z-10">
          <div className={styles.modalContent}>
            <div className={styles.modalVideo}>
            <Iframe url={`https://player.vimeo.com/video/${videoId}?autoplay=1`}
              width="100%"
              height="320px"
              id={videoId}
              className=""
              display="block"
              position="relative"
              allow="autoplay; fullscreen" />
            </div>
            <button
                className={styles.modalClose}
                onClick={() => setIsOpen(false)}
              >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-12 h-12">
                <path strokeLinecap="round" strokeLinejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default VideoModal;